import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { MapViewRightSlideOutContent } from "./RightSlideOut"
import { MapViewTopBar } from "./TopBar"

export const mapViewLayoutHandle: StaticDataRouteOption = {
	rightSlideOut: MapViewRightSlideOutContent,
	hideRightSlideOut: false,
	leftSlideOut: AppNavigation,
	topBar: MapViewTopBar,
}
